<template>
  <div>
    <HeaderComponent/>
    <History v-if="getUser" />
    <FooterComponent/>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderPayment';
import History from '@/components/TopupHistoryTable';
import FooterComponent from '@/components/Footer.vue';
export default {
  name: "TopupHistory",
  components: {
    HeaderComponent,
    History,
    FooterComponent,
  },
  computed: {
    getUser() {
      return this.$store.state.authUser
    }
  }
}
</script>

<style scoped>
</style>